import React, { useEffect, useState } from 'react';
import { Container, IconButton, Tooltip } from '@mui/material';
import { dispatch, useSelector } from '../../../redux/store';
import { PATH_DASHBOARD } from '../../../routes/paths';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import DataGridTable from '../../../components/table/DataGridTable';
import { accessVerify, capitalize, safeJSONParse, utcMoment } from '../../../utils/common';
import { getOneTimeCustomers } from '../../../redux/slices/customerRedux/customerRedux';
import PermissionRequired from '../../errorPages/permissionRequired';
import { InfoIcon } from '../../../theme/overrides/CustomIcons';

export default function OneTimeCustomerList() {
  const { themeStretch } = useSettings();
  const [customerList, setCustomerList] = useState([]);
  const { oneTimeCustomer } = useSelector((state) => state.customers);

  useEffect(() => {
    dispatch(getOneTimeCustomers());
  }, []);

  useEffect(() => {
    if (oneTimeCustomer?.length > 0) {
      setCustomerList(
        oneTimeCustomer?.map((value) => {
          const foodList = safeJSONParse(value?.foods);
          return {
            date: utcMoment(value?.dateTime).format('YYYY-MM-DD'),
            time: utcMoment(value?.dateTime).format('HH:mm'),
            ...value,
            foods: foodList?.map((food) => ` ${food.foodId}) ${food.foodName} : ${food.qty}\n`),
          };
        })
      );
    } else {
      setCustomerList([]);
    }
  }, [oneTimeCustomer]);

  const columns = !customerList?.[0]
    ? []
    : Object.keys(customerList?.[0])
        .map((value) => {
          if (['dateTime'].includes(value)) {
            return {};
          } else if (value === 'foods') {
            return {
              accessorKey: 'foods',
              header: 'Order',
              Cell: ({ cell, row }) => {
                return (
                  <Tooltip title={<pre style={{ margin: 0 }}>{row.original.foods}</pre>} arrow placement={'top'}>
                    <IconButton>
                      <InfoIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                );
              },
            };
          } else {
            return {
              accessorKey: value,
              header: capitalize(value),
            };
          }
        })
        ?.filter((value) => value?.accessorKey);

  const [rowSelection, setRowSelection] = useState(false);
  return (
    <Page title={`OneTime Customer List`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={`OneTime Customer List`}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Sale',
              href: '',
            },
            { name: `OneTime Customer List` },
          ]}
          action={<></>}
        />

        {accessVerify('CUSTOMERS_VIEW') ? (
          <DataGridTable
            name={'OneTime Customer List'}
            data={customerList}
            column={columns}
            isLoading={false}
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            enableRowActions={false}
            enablePinning={false}
            enableRowSelection={false}
            isRowClickable={true}
            onRowClick={(row) => {}}
            renderRowActionItems={(value, closeMenu) => []}
          />
        ) : (
          <PermissionRequired />
        )}
      </Container>
    </Page>
  );
}
